import { isIOS } from '../../helpers/index'
import { isAkulakuAndroid, isAkulakuIOS } from '../is'
import agentAndroid from '../android/index'
import agentIOS from '../iOS/index'
import agentDevelop from '../develop/index'

let agent = agentDevelop
if (isAkulakuAndroid()) {
  agent = agentAndroid
}
if (isAkulakuIOS()) {
  agent = agentIOS
}

export default agent
